import reportFxDataList from "../../../src/data/reportFxData.json";
import { reportFxData } from "./type";

export class ReportFxService {
  async getReportFxFile(filters: any) {
    const { data } = await this.getReportFx(0, 1000000, filters);
    return data;
  }

  async getBankersByName(name: string): Promise<string[]> {
    if (!name || name.trim().length === 0) {
      return [];
    }

    const normalizedSearch = name
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();

    // devuelve todos los banqueros cuyos nombres contienen el texto buscado (sin normalizar)
    // y sin duplicados
    const bankers = reportFxDataList.data
      .map((item) => item.bankerName)
      .filter((value, index, self) => self.indexOf(value) === index);

    return bankers.filter((banker) =>
      banker
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .includes(normalizedSearch)
    );
  }

  async getBankersByRut(rut: string): Promise<string[]> {
    if (!rut || rut.trim().length === 0) {
      return [];
    }

    const normalizedSearch = rut.replace(/[.-]/g, "").trim();

    // devuelve todos los RUT de banqueros que comienzan con el texto buscado (sin puntos ni guion)
    // y sin duplicados
    const bankers = reportFxDataList.data
      .map((item) => item.bankerRut)
      .filter((value, index, self) => self.indexOf(value) === index);

    return bankers.filter((bankerRut) =>
      bankerRut.replace(/[.-]/g, "").startsWith(normalizedSearch)
    );
  }

  async getReportFx(
    filters: any,
    page?: number,
    size?: number
  ): Promise<{ data: reportFxData }> {
    let filteredReportFx = reportFxDataList.data; // sin filtro por clientID es mas general

    if (filters) {
      if (filters.date && filters.date.length === 2) {
        const [startRaw, endRaw] = filters.date.map((d: string) => new Date(d));

        // Normalizar las fechas al inicio del día
        const start = new Date(startRaw.setHours(0, 0, 0, 0));
        const end = new Date(endRaw.setHours(23, 59, 59, 999)); // incluir todo el día

        filteredReportFx = filteredReportFx.filter((item) => {
          const [dd, mm, yyyy] = item.date.split("/");
          const itemDate = new Date(`${yyyy}-${mm}-${dd}T00:00:00`);
          return itemDate >= start && itemDate <= end;
        });
      }

      if (filters.clientRut) {
        filteredReportFx = filteredReportFx.filter((item) =>
          item.userRut
            .replace(/[.-]/g, "")
            .includes(filters.clientRut.replace(/[.-]/g, ""))
        );
      }

      if (filters.clientName) {
        filteredReportFx = filteredReportFx.filter((item) =>
          item.userName.toLowerCase().includes(filters.clientName.toLowerCase())
        );
      }

      if (filters.bankerRut) {
        filteredReportFx = filteredReportFx.filter((item) =>
          item.bankerRut
            .replace(/[.-]/g, "")
            .includes(filters.bankerRut.replace(/[.-]/g, ""))
        );
      }

      if (filters.bankerName) {
        filteredReportFx = filteredReportFx.filter((item) =>
          item.bankerName
            .toLowerCase()
            .includes(filters.bankerName.toLowerCase())
        );
      }

      if (filters.operation) {
        filteredReportFx = filteredReportFx.filter(
          (item) => item.operation === filters.operation
        );
      }
    }

    if (page !== undefined && size !== undefined) {
      const total = filteredReportFx.length;
      const start = page * size;
      const end = start + size;
      const paginatedRisk = filteredReportFx.slice(start, end);
      return {
        data: {
          total,
          totalPages: Math.ceil(total / size),
          page,
          pageSize: size,
          reports: paginatedRisk,
        },
      };
    }

    return {
      data: {
        total: filteredReportFx.length,
        totalPages: 1,
        page: 0,
        pageSize: filteredReportFx.length,
        reports: filteredReportFx,
      },
    };
  }
}
